var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h3",
      {
        staticClass: "text-center mb-4",
        attrs: { "data-problem-title": _vm.problem.alias }
      },
      [
        _vm._v(" " + _vm._s(_vm.title) + " "),
        _vm.showVisibilityIndicators
          ? [
              _vm.problem.quality_seal || _vm.problem.visibility === 3
                ? _c("img", {
                    staticClass: "mr-2",
                    attrs: {
                      src: "/media/quality-badge.png",
                      title: _vm.T.wordsHighQualityProblem
                    }
                  })
                : _vm._e(),
              _vm.problem.visibility === 1 || _vm.problem.visibility === -1
                ? _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: {
                      icon: ["fas", "exclamation-triangle"],
                      title: _vm.T.wordsWarningProblem
                    }
                  })
                : _vm._e(),
              _vm.problem.visibility === 0 || _vm.problem.visibility === -1
                ? _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: {
                      icon: ["fas", "eye-slash"],
                      title: _vm.T.wordsPrivate
                    }
                  })
                : _vm._e(),
              _vm.problem.visibility <= -2
                ? _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: {
                      icon: ["fas", "ban"],
                      title: _vm.T.wordsBannedProblem,
                      color: "darkred"
                    }
                  })
                : _vm._e()
            ]
          : _vm._e(),
        _vm.showEditLink
          ? _c(
              "a",
              { attrs: { href: "/problem/" + _vm.problem.alias + "/edit/" } },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "edit"] } })],
              1
            )
          : _vm._e()
      ],
      2
    ),
    _vm.problem.accepts_submissions
      ? _c("table", { staticClass: "table table-bordered mx-auto w-75 mb-0" }, [
          _c("tr", [
            _c("th", { staticClass: "align-middle", attrs: { scope: "row" } }, [
              _vm._v(_vm._s(_vm.T.wordsPoints))
            ]),
            _c("td", { staticClass: "align-middle" }, [
              _vm._v(_vm._s(_vm.problem.points))
            ]),
            _c("th", { staticClass: "align-middle", attrs: { scope: "row" } }, [
              _vm._v(_vm._s(_vm.T.arenaCommonMemoryLimit))
            ]),
            _c(
              "td",
              {
                staticClass: "align-middle",
                attrs: { "data-memory-limit": "" }
              },
              [_vm._v(_vm._s(_vm.memoryLimit))]
            )
          ]),
          _c("tr", [
            _c("th", { staticClass: "align-middle", attrs: { scope: "row" } }, [
              _vm._v(_vm._s(_vm.T.arenaCommonTimeLimit))
            ]),
            _c("td", { staticClass: "align-middle" }, [
              _vm._v(_vm._s(_vm.timeLimit))
            ]),
            _c("th", { staticClass: "align-middle", attrs: { scope: "row" } }, [
              _vm._v(" " + _vm._s(_vm.T.arenaCommonOverallWallTimeLimit) + " ")
            ]),
            _c("td", { staticClass: "align-middle" }, [
              _vm._v(_vm._s(_vm.overallWallTimeLimit))
            ])
          ]),
          _c(
            "tr",
            [
              !_vm.showVisibilityIndicators
                ? [
                    _c(
                      "th",
                      { staticClass: "align-middle", attrs: { scope: "row" } },
                      [_vm._v(_vm._s(_vm.T.wordsInOut))]
                    ),
                    _c("td", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.T.wordsConsole))
                    ])
                  ]
                : _vm._e(),
              _c(
                "th",
                { staticClass: "align-middle", attrs: { scope: "row" } },
                [_vm._v(" " + _vm._s(_vm.T.problemEditFormInputLimit) + " ")]
              ),
              _c("td", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(_vm.inputLimit))
              ])
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }